import github from '../../assets/icons/github.png';
import rsschool from '../../assets/icons/rsschool.png';

export const contacts = [
  { title: 'emp74ark', url: 'https://github.com/emp74ark', icon: github },
  { title: 'andreygudin', url: 'https://github.com/AndreyGudin', icon: github },
  { title: 'SteGlaset', url: 'https://github.com/SteGlaset', icon: github },
  { title: 'RS-School', url: 'https://rs.school/', icon: rsschool },
];
